import { ReactComponent as SpeakerIcon } from '@Icons/additional/news/speaker.svg';
import { ReactComponent as LandmarksIcon } from '@Icons/additional/news/landmarks.svg';
import { ReactComponent as StarIcon } from '@Icons/additional/news/star.svg';
import { LatestUpdatesType } from '@Types/index';

type NewsIcon = {
  [keys in LatestUpdatesType]: JSX.Element;
};

export const NewsIcon: NewsIcon = {
  Announcement: <SpeakerIcon />,
  'Business News': <LandmarksIcon />,
  'New Project': <StarIcon />,
};
